import { ListActions } from './ListActions';
import { ListActionStatuses } from './ListActionStatuses';

/**
 * queries
 *
 * @type {{ListActions: ((function({}=): Promise<*>)|*), ListActionStatuses: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  ListActions,
  ListActionStatuses,
};
